<div fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}">

  <div fxLayoutAlign="center center" class="layout-padd text-center">

    <span class="mat-subheading-1">{{'deleteAdressComponent.deletecard' | translate}} {{from === 'card' ?
      'carte' :from === 'pms'?'option de paiement ': 'adresse'}} ?</span>

  </div>

  <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd" fxLayoutGap="10px">

    <button fxFlex mat-stroked-button color="warn" (click)="closeDial()" angulartics2On="click"
      angularticsAction="cancelDelete"
      angularticsCategory="{{ from === 'card' ?'card':from === 'pms'? 'paymentMethods' : 'addresses'}}">{{"button.no" | translate}}</button>
    <button fxFlex mat-stroked-button color="accent" (click)="deleteWhat()" angulartics2On="click"
      angularticsAction="confirmDelete"
      angularticsCategory="{{ from === 'card' ?'card':from === 'pms'? 'paymentMethods'  : 'addresses'}}">{{"button.yes" | translate}}</button>

  </div>

</div>


<app-popup-loader [flagLoading]="loader" [size]="30"></app-popup-loader>
